export enum IssueSortBy {
  PRIORITY,
  RAISED,
}

export enum IssueClickOptions {
  OPEN_OVERVIEW,
  OPEN_CORRECTIVE_WORK,
  OPEN_ADD_TO_WORK_ORDER,
}

export enum WorkOrderSortBy {
  DEADLINE,
  PRIORITY,
}

export enum WorkOrderClickOptions {
  OPEN_OVERVIEW,
  PERFORM_WORK,
}

export enum WorkOrderIssueSortBy {
  DESIGNATION,
  ISSUE_PRIORITY,
}

export enum WorkOrderItemSortBy {
  DESIGNATION,
  ITEM_ID,
}

export enum PerformedWorkSortBy {
  PERFORMED_DATE_TIME,
  ISSUE_RAISED,
}

export enum NotPerformedEntityClickOptions {
  OPEN_ENTITY_OVERVIEW,
  PERFORM_WORK,
}

export enum PerformedEntityClickOptions {
  OPEN_PERFORMED_WORK,
  OPEN_ENTITY_OVERVIEW,
}

export enum ItemSortBy {
  ISSUE_WORK_ORDER_PRIORITY,
  DESIGNATION,
}

export enum ItemClickOptions {
  OPEN_OVERVIEW,
  DISPLAY_ON_LAYOUT,
}

export enum LayoutWithZoneSortBy {
  LAYOUT_DESIGNATION,
  ISSUE_WORK_ORDER_PRIORITY,
}

export enum LayoutWithZoneClickOptions {
  OPEN_OVERVIEW,
  DISPLAY_ON_LAYOUT,
}

export enum ModelSortBy {
  LAYOUT_DESIGNATION,
  AREA_DESIGNATION,
}

export enum ModelClickOptions {
  OPEN_ITEM_LIST_FOR_AREA,
  OPEN_AREA_OVERVIEW,
}

export enum StatisticalMethod {
  MEAN,
  MEDIAN,
  MODE,
}

export enum ConfigSortOrder {
  ASCENDING = 1,
  DESCENDING = -1,
}
